import { AdminOrganizationAutoCompleteType } from 'api/types';
import { actionsFactories } from 'store/entities/utils';
import { GetAdminOrganizationsParentAutoCompleteParamsType } from './types';
import * as keyWindowNames from './keyWindowNames';

export const getAdminOrganizationsParentAutoComplete = actionsFactories.createGetPaginatedManyActionsFactory<
  AdminOrganizationAutoCompleteType,
  GetAdminOrganizationsParentAutoCompleteParamsType
>()(
  'GET_ADMIN_ORGANIZATIONS_PARENT_AUTOCOMPLETE_REQUEST',
  'GET_ADMIN_ORGANIZATIONS_PARENT_AUTOCOMPLETE_SUCCESS',
  'GET_ADMIN_ORGANIZATIONS_PARENT_AUTOCOMPLETE_FAILURE',
  'GET_ADMIN_ORGANIZATIONS_PARENT_AUTOCOMPLETE_RESET',
  keyWindowNames.adminOrganizationsSearch,
);
